import { render, staticRenderFns } from "./PaypalEditor.vue?vue&type=template&id=081def7b&scoped=true&"
import script from "./PaypalEditor.vue?vue&type=script&lang=ts&"
export * from "./PaypalEditor.vue?vue&type=script&lang=ts&"
import style0 from "./PaypalEditor.vue?vue&type=style&index=0&id=081def7b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081def7b",
  null
  
)

export default component.exports